import angular from 'angular';
import localePtBr from './angular-locale_pt-br'
import soTranslateSettings from './soTranslate'
import soGoToLang from './soGoToLang'
import extDbTranslateConfig from './extDbTranslateConfig'
import extDbTranslate from './extDbTranslate'

angular.module("ngLocale", [], localePtBr)
angular.module("soTranslate", [])
    .provider('soTranslateSettings', soTranslateSettings)
    .provider('extDbTranslateConfig', extDbTranslateConfig)
    .filter('soGoToLang', soGoToLang)
    .filter('extDbTranslate', extDbTranslate)


// WEBPACK FOOTER //
// ./src/app/scripts/modules/index.js